/* ReviewsLeftColumn.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _21 = "._2rko1koz{border-radius:var(--ds-border-radius-300,.75rem)}";
const _20 = "._11q7hp5a{background:var(--ds-surface-raised,#fff)}";
const _19 = "._19itzgxb{border:1px solid var(--ds-border,#091e4224)}";
const _18 = "._1yt44ar7{padding:var(--ds-space-200,1pc) var(--ds-space-300,24px)}";
const _17 = "._bpsp1pd9 a{font-weight:var(--ds-font-weight-semibold,600)}";
const _16 = "._19tb1j6v a{font-size:1rem}";
const _15 = "._19pkoahv{margin-top:var(--ds-space-600,3pc)}";
const _14 = "._otyr1b66{margin-bottom:var(--ds-space-050,4px)}";
const _13 = "._4cvr1q9y{align-items:baseline}";
const _12 = "._1e0c1txw{display:flex}";
const _11 = "._18s81bpf{margin:var(--ds-space-100,8px) 0}";
const _10 = "._qliy1gjq h3{color:var(--ds-text-subtle,#44546f)}";
const _9 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _8 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _7 = "._18u01b66{margin-left:var(--ds-space-050,4px)}";
const _6 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _5 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LinkButton } from '@atlaskit/button/new';
import StandardButton from '@atlaskit/button/standard-button';
import { media } from '@atlaskit/primitives/responsive';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { BodyNormal, Button, H3, H4, H5, H6, Ratings, TOTAL_STARS } from '@atlassian/mpac-primitives';
import { HostingDisplayName } from '@atlassian/mpac-types';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { ANALYTICS_REVIEW_READ_MORE_BUTTON } from '../../../../../analytics/Events';
import { TEST_ID } from '../../../../../constants';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _4 = "@media not all and (min-width:48rem){._13zmn7od{position:unset}._1mbf1wug{top:auto}}";
const _3 = "._154iidpf{top:0}";
const _2 = "._ca0qxy5q{padding-top:var(--ds-space-400,2pc)}";
const _ = "._kqsw1if8{position:-webkit-sticky;position:sticky}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kqsw1if8 _ca0qxy5q _154iidpf _13zmn7od _1mbf1wug", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const HeadingWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "header",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyrxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeadingWrapper.displayName = 'HeadingWrapper';
}
const TotalStarsH5 = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkpxbi _18u01b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TotalStarsH5.displayName = 'TotalStarsH5';
}
const RatingsText = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkpxbi _syaz1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RatingsText.displayName = 'RatingsText';
}
const GuidelineBannerWrapper = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkxy5q _qliy1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  GuidelineBannerWrapper.displayName = 'GuidelineBannerWrapper';
}
const GuidelineContentWrapper = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s81bpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  GuidelineContentWrapper.displayName = 'GuidelineContentWrapper';
}
const RatingsNumberContainer = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1q9y _otyr1b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RatingsNumberContainer.displayName = 'RatingsNumberContainer';
}
const WriteReviewButtonWrapper = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_15, _16, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkoahv _19tb1j6v _bpsp1pd9", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  WriteReviewButtonWrapper.displayName = 'WriteReviewButtonWrapper';
}
const ReviewsCard = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18, _19, _20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt44ar7 _19itzgxb _11q7hp5a _2rko1koz", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ReviewsCard.displayName = 'ReviewsCard';
}
const getRoundedRating = rating => Number(rating.toFixed(1));
// eslint-disable-next-line max-lines-per-function
export const ReviewsLeftColumn = _ref10 => {
  let {
    hosting,
    isLoggedIn,
    loginHref,
    handleShowReviewForm,
    selfUserReview,
    appRating,
    appRatingByHostingType,
    productHostingOptions,
    isServerAppEos
  } = _ref10;
  const [guidelineExpanded, setGuidelineExpanded] = React.useState(false);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const renderReviewButton = () => {
    const testId = isLoggedIn ? TEST_ID.REVIEWS_TAB_WRITE_EDIT_REVIEW_BUTTON : TEST_ID.REVIEWS_TAB_SIGN_IN_LINK;
    if (!isLoggedIn && loginHref) {
      return /*#__PURE__*/_jsx(WriteReviewButtonWrapper, {
        children: /*#__PURE__*/_jsx(LinkButton, {
          testId: testId,
          href: loginHref,
          children: "Sign in to write a review"
        })
      });
    } else if ((selfUserReview === null || selfUserReview === void 0 ? void 0 : selfUserReview.status) !== 'pending' && (selfUserReview === null || selfUserReview === void 0 ? void 0 : selfUserReview.status) !== 'inprogress') {
      return /*#__PURE__*/_jsx(WriteReviewButtonWrapper, {
        children: /*#__PURE__*/_jsx(Button, {
          testId: testId,
          "aria-haspopup": "dialog",
          onClick: handleShowReviewForm,
          children: selfUserReview && (selfUserReview.status === 'approved' || selfUserReview.status === undefined) ? 'Edit review' : 'Write a review'
        })
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(HeadingWrapper, {
      children: /*#__PURE__*/_jsxs(H4, {
        as: "h2",
        "data-testid": TEST_ID.REVIEWS_TAB_HEADING,
        children: ["Reviews for", ' ', hosting === AtlassianProductHostingType.DataCenter ? HostingDisplayName[hosting] : HostingDisplayName[hosting].toLowerCase()]
      })
    }), /*#__PURE__*/_jsxs(ReviewsCard, {
      children: [!!appRatingByHostingType.numRatings && /*#__PURE__*/_jsxs(_Fragment, {
        children: [!!appRatingByHostingType.numRatings && /*#__PURE__*/_jsxs(RatingsNumberContainer, {
          children: [/*#__PURE__*/_jsx(H3, {
            as: "span",
            children: getRoundedRating(appRatingByHostingType.avgStars)
          }), /*#__PURE__*/_jsx(TotalStarsH5, {
            children: /*#__PURE__*/_jsxs(H5, {
              as: "span",
              children: ["/ ", TOTAL_STARS]
            })
          })]
        }), /*#__PURE__*/_jsx(Ratings, {
          testId: "ratings",
          ratings: appRatingByHostingType,
          size: "large",
          showNumberRatings: false
        }), productHostingOptions.length > 1 ? /*#__PURE__*/_jsxs(RatingsText, {
          children: ["Based on ", appRatingByHostingType.numRatings, " out of ", appRating.numRatings, " reviews across hosting types"]
        }) : /*#__PURE__*/_jsxs(RatingsText, {
          children: ["Based out of ", appRatingByHostingType.numRatings, " reviews"]
        })]
      }), !isServerAppEos && renderReviewButton(), /*#__PURE__*/_jsxs(GuidelineBannerWrapper, {
        children: [/*#__PURE__*/_jsx(H6, {
          as: "h3",
          children: "Review guidelines"
        }), guidelineExpanded ? /*#__PURE__*/_jsx(GuidelineContentWrapper, {
          children: "Our new review guidelines ensure that all the reviews are submitted by actual users of the app. Customers are asked to confirm their usage of the app before submitting a review. Only current users or those who have used the app in the last six months are eligible to submit a review."
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(GuidelineContentWrapper, {
            children: "Our new review guidelines ensure that all the reviews are submitted by actual users of the app..."
          }), /*#__PURE__*/_jsx(StandardButton, {
            onClick: () => {
              setGuidelineExpanded(true);
              fireAnalyticsEvent({
                eventType: ButtonClickedEvent,
                actionSubjectId: ANALYTICS_REVIEW_READ_MORE_BUTTON,
                atrributes: {
                  label: 'Read More about Review Guidelines'
                }
              });
            },
            appearance: "link",
            spacing: "none",
            children: "Read more"
          })]
        })]
      })]
    })]
  });
};